/**
 * ตัวช่วยสร้างและดาวน์โหลดไฟล์ CSV
 * ใส่ BOM (﻿) เพื่อให้ Excel อ่านภาษาไทยได้ถูกต้อง
 */

/** แปลงค่า 1 ช่องให้อยู่ในรูปแบบ CSV (ครอบด้วย " และ escape " ภายใน) */
function toCsvField(value: unknown): string {
  const text = value === null || value === undefined ? '' : String(value);
  return `"${text.replace(/"/g, '""')}"`;
}

/** สร้างเนื้อหา CSV จากหัวตารางและข้อมูล */
export function buildCsvContent(headers: string[], rows: unknown[][]): string {
  return [headers, ...rows]
    .map(row => row.map(toCsvField).join(','))
    .join('\r\n');
}

/**
 * ดาวน์โหลดข้อมูลเป็นไฟล์ CSV
 * @param fileName ชื่อไฟล์ (ไม่ต้องใส่ .csv)
 */
export function downloadCsv(fileName: string, headers: string[], rows: unknown[][]): void {
  const csvContent = '﻿' + buildCsvContent(headers, rows);
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.download = `${fileName}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(url);
}

/** วันที่สำหรับต่อท้ายชื่อไฟล์ เช่น 2026-09-17 */
export function csvFileDateSuffix(date: Date = new Date()): string {
  return date.toISOString().split('T')[0];
}
